export default "__VITE_ASSET__f7ab3466__"